import { Select } from "antd";
import React from "react";
import { useSelector } from "react-redux";

interface Props {
  className?: string;
  value?: string[];
  onChange?: (value: string[]) => void;
}

const MultiDesignationSelect = ({ value, onChange, className = "" }: Props) => {
  const {
    designation_list_data = [],
  }: {
    designation_list_data: Array<Designation>;
    // @ts-ignore
  } = useSelector((state) => state.designation);

  return (
    <Select
      className={`${className}`}
      mode="multiple"
      value={value}
      onChange={onChange}
      placeholder="Select Designations"
    >
      {designation_list_data.map((designation) => (
        <Select.Option key={designation.id} value={designation.id}>
          {designation.name}
        </Select.Option>
      ))}
    </Select>
  );
};

export default MultiDesignationSelect;
